/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ItemVariantResult } from '../../models/item-variant-result';

export interface ItemVariantTypesItemVariantTypeIdPut$Params {
  'Active-Tenant-Identifier': string;
  itemVariantTypeId: string;
      body: ItemVariantResult
}

export function itemVariantTypesItemVariantTypeIdPut(http: HttpClient, rootUrl: string, params: ItemVariantTypesItemVariantTypeIdPut$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, itemVariantTypesItemVariantTypeIdPut.PATH, 'put');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('itemVariantTypeId', params.itemVariantTypeId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

itemVariantTypesItemVariantTypeIdPut.PATH = '/item-variant-types/{itemVariantTypeId}';
